// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { pencil16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-pencil': IconPencil;
    }
}

/**
 * The icon component for the 'pencil' icon
 */
export class IconPencil extends IconSvg {
    public constructor() {
        super(pencil16X16);
    }
}

registerIconSvg('icon-pencil', IconPencil);
export const iconPencilTag = 'nimble-icon-pencil';
